import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LangLayout from "./components/LangLayout";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./pages/Home";
import Guides from "./pages/Guides";
import GuideDetail from "./pages/GuideDetail";
import Assessment from "./pages/Assessment";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import VerifyEmail from "./pages/VerifyEmail";
import CheckInbox from "./pages/CheckInbox";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import Unsubscribed from "./pages/Unsubscribed";
import { Toaster } from "sonner";

function VerifyOnlyLayout() {
  return (
    <div className="relative min-h-screen grain">
      <header className="container py-6 flex items-center justify-between">
        <a href="/" className="inline-flex items-baseline gap-1">
          <span className="font-display text-card font-bold">The Life</span>
          <span className="ed-italic text-card text-gold">Plot</span>
        </a>
      </header>
      <main className="relative z-10">
        <VerifyEmail />
      </main>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

function RootRedirect() {
  const stored = typeof window !== "undefined" ? localStorage.getItem("lp_lang") : null;
  const browser =
    typeof navigator !== "undefined" && (navigator.language || "").toLowerCase().startsWith("ro")
      ? "ro"
      : "en";
  const target = stored === "ro" || stored === "en" ? stored : browser;
  return <Navigate to={`/${target}`} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            {/* Verification link is top-level — VerifyEmail handles its own minimal layout */}
            <Route path="/auth/verify" element={<VerifyOnlyLayout />} />

            <Route path="/:lang" element={<LangLayout />}>
              <Route index element={<Home />} />
              <Route path="guides" element={<Guides />} />
              <Route path="guides/:slug" element={<GuideDetail />} />
              <Route path="assessment" element={<Assessment />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog/:slug" element={<BlogPost />} />
              <Route path="contact" element={<Contact />} />
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />
              <Route path="check-inbox" element={<CheckInbox />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="reset-password/:token" element={<ResetPassword />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="checkout/success" element={<CheckoutSuccess />} />
              <Route path="checkout/cancel" element={<CheckoutCancel />} />
              <Route path="legal/privacy" element={<Privacy />} />
              <Route path="legal/terms" element={<Terms />} />
              <Route path="unsubscribed" element={<Unsubscribed />} />
            </Route>
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
